import React, { useEffect, useState } from 'react'

import GoogleMap from '../Common/GoogleMap';
import CustomImageMap from '../Common/CustomImageMap';

import { addSiteZoneMapAPI, getDeviceBySiteIdAPI } from '../../../../services/configurationServices';
import { attachalertevidences } from '../../../../services/alertAuthService';

import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';

import Swal from 'sweetalert2';

import { hasDecimalPoint, isWholeNumberWithDecimalPoint } from '../../../../utils/utils';
import MapButtons from '../Common/MapButtons';
import { WarningToast } from '../../../../CustomHooks/WarningToast';

const ZoneMap = ({ isDarkTheme, selectedZone, site, getZoneList }) => {
    console.count("ZoneMap Render Count")
    console.log("ZoneMap", site)
    const hiddenCamFileInput = React.useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageFileName, setImageFileName] = useState("");
    const [selectedItem, setSelectedItem] = useState("gis_map");
    const [selectedMap, setSelectedMap] = useState('GIS Map');
    const [deviceList, setDeviceList] = useState([]);
    const [deviceMasterList, setDeviceMasterList] = useState([]);
    const [droppedItems, setDroppedItems] = useState([]);
    const [editForm, setEditForm] = useState(false);
    const [markerList, setMarkerList] = useState([]);
    const [imageUrl, setImageUrl] = useState("");
    const [cancelCount, setCancelCount] = useState(0)
    const [disableButton, setDisableButton] = useState(false)
    // const [allowGoogle, setAllowGoogle] = useState(true)
    const [allowCustom, setAllowCustom] = useState(true)
    

    useEffect(() => {
        setEditForm(false)
    }, [selectedZone])

    useEffect(() => {
        if (selectedZone?.SiteID != 0) {
            console.log("selectedZoneselectedZone", site);
            console.log("selectedZoneselectedZone", selectedZone);
            if ((site?.isMap === true || site?.isMap === null) && (selectedZone?.isMap === true || selectedZone?.isMap === null)) {
                setSelectedItem("gis_map")
            } else {
                setSelectedItem("custom")
            }
            setImageUrl(selectedZone?.mapUrl)
            setSelectedImage(selectedZone?.mapUrl)
            let fnameList = selectedZone?.mapUrl?.split(`/`);
            if (fnameList?.length > 0) {
                let fname = fnameList[fnameList?.length - 1]
                setImageFileName(fname || "")
            } else {
                setImageFileName("")
            }
            getDeviceBySiteId(site?.SiteID, selectedZone?.SiteID)
        }
    }, [selectedZone, cancelCount])

    const getDeviceBySiteId = (siteId, zoneId) => {
        getDeviceBySiteIdAPI(siteId, zoneId)
            .then((res) => {
                if (res.Status == "success" && res.Data != null) {
                    let modifiedArr = res.Data.map((item) => {
                        return {
                            ...item,
                            isSelected: !(item?.Lat == null || item?.Lat == "0.0"),
                            isTouched: false
                        }
                    })
                    let anotherArr = modifiedArr.filter(item => (item.isSelected && (!hasDecimalPoint(item?.Lat) || isWholeNumberWithDecimalPoint(item?.Lat)))).map((i) => {
                        return {
                            ...i,
                            position: {
                                x: i?.Lat,
                                y: i?.Long
                            }
                        }
                    })
                    setDroppedItems(anotherArr)
                    let tempArr = modifiedArr.filter(item => (item.isSelected && (hasDecimalPoint(item?.Lat) && !isWholeNumberWithDecimalPoint(item?.Lat)))).map((i) => {
                        return {
                            ...i,
                            position: {
                                lat: i?.Lat,
                                lng: i?.Long
                            }
                        }
                    })
                    setMarkerList(tempArr)
                    setDeviceMasterList(modifiedArr)
                    setDeviceList(modifiedArr)
                } else {
                    setDroppedItems([])
                    setMarkerList([])
                    setDeviceMasterList([])
                    setDeviceList([])
                }
            })
            .catch(err => console.log(err))
    }

    const handleChange = (event) => {
        event.stopPropagation()
        // setSelectedMap(event.target.value);
        if(event.target.value == "gis_map"){
                    //Now here I need to check if image is present. If image is present then inform user
                    //to delete it and then proceed to add markers in it.
                    console.log("MarkerListMap", markerList)
                    if(site?.isMap === false){
                        ErrorToast("You are using custom map in your site so using google map for your zone is not allowed.")
                        return;
                    }
                    if(selectedImage != null){
                        Swal.fire({
                            title: "Note",
                            text: "If you want to select google map to mark the markers, then kindly delete the custom map image and markers.",
                            icon: "warning",
                            showCancelButton: true,
                            cancelButtonText: "No don't delete it",
                            confirmButtonColor: "#027aaa",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, delete it!",
                        }).then((result) => {
                            if(result.isConfirmed){
                                deleteAllMarkers(true, event.target.value);
                            }else{
                                return;
                            }
                        })
                        .catch(err => console.log(err))
                    }else{
                        setSelectedItem(event.target.value)
                    }
                }else{
                    //Now here I need to check if on the google map markers are present
                    //If markers are present inform user to delete it and then proceed to check the custom radio 
                    console.log("MarkerListMap", markerList)
                    if(markerList.length > 0){
                        Swal.fire({
                            title: "Note",
                            text: "If you want to select custom map to mark the markers, then kindly delete the markers added on the Google map.",
                            icon: "warning",
                            showCancelButton: true,
                            cancelButtonText: "No don't delete it",
                            confirmButtonColor: "#027aaa",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, delete it!",
                        }).then((result) => {
                            if(result.isConfirmed){
                                deleteAllMarkers(true, event.target.value);
                            }else{
                                return;
                            }
                        })
                        .catch(err => console.log(err))
                    }else{
                        setSelectedItem(event.target.value)
                    }
                }
        // setSelectedItem(event.target.value)
    };

    const handleUploadImageClick = (event) => {
        if (selectedItem == "gis_map") {
            ErrorToast("Kindly enable the custom map to upload a image for adding markers on the map.")
            return;
        }
        // event.preventDefault()
        setDisableButton(true)
        hiddenCamFileInput.current.click();
    }

    const handleImageChange = (event) => {
        if(selectedItem == "gis_map"){
            ErrorToast("Kindly enable the custom map to upload an image for adding markers on the map.")
            return;
        }
        console.log("handleUploadImageClick", event)
        const files = event.target.files;
        if (files && files[0]) {
            const file = files[0];
            const fileType = file.type.split('/')[0];
            const allowedFileTypes = ['image'];
            if (allowedFileTypes.includes(fileType)) {
                if (file.size <= 5242880) {
                    const imageUrl = URL.createObjectURL(file);
                    setImageFileName(file.name)
                    setSelectedImage(imageUrl);
                    onAddFileCallback(file);
                } else {
                    console.log('File size should be less than 5MB.');
                    WarningToast("File size should be less than 5MB.")
                }
            } else {
                console.log('Please select only images.');
            }

        }
        // const file = event.target.files[0];
        // console.log("handleUploadImageClick", file)
        // if (file) {
        //   const imageUrl = URL.createObjectURL(file);
        //   setSelectedImage(imageUrl);
        // }
    };

    const onAddFileCallback = (files) => {
        console.log("onAddFileCallback", files)
        try {
            let newfile = files[files.length == 0 ? 0 : files.length - 1]
            let reader = new FileReader()
            reader.readAsDataURL(files);
            reader.onload = (e) => {
                Attachalertevidences(e.target.result, files.name)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const Attachalertevidences = (e, fname) => {
        const extension = fname.split('.').pop();
        let LoggedInUser = JSON.parse(localStorage.getItem('user'))
        try {
            var obj = {
                "AttachedDocTitle": fname,
                "AlertId": 1,
                "userId": LoggedInUser.Id,
                "Base64String": e,
                "DocType": extension
            }
            attachalertevidences(obj).then((evidenceRes) => {
                if (evidenceRes.Status == "success") {
                    setDisableButton(false)
                    setImageUrl(evidenceRes?.Data?.documentUrl)
                }
            })
        } catch (error) {
            setDisableButton(false)
            console.error(error)
        }
    }

    const onSaveMapDetails = () => {
        // First we filter only those device markers that were touced that is either add or removed.
        let masterCollection = deviceMasterList.filter((item) => item.isTouched);
        let updateMarkerData = []
        for (let i = 0; i < masterCollection.length; i++) {
            // Check if device id is present in the markersList.
            let obj = {};
            let isPresent = markerList.find((item) => item.DeviceId == masterCollection[i].DeviceId)
            let isCustomPresent = droppedItems.find((item) => item.DeviceId == masterCollection[i].DeviceId)
            if (isPresent) {
                obj = {
                    ...masterCollection[i],
                    Lat: isPresent.position.lat,
                    Long: isPresent.position.lng
                }
            } else if (isCustomPresent) {
                obj = {
                    ...masterCollection[i],
                    Lat: isCustomPresent.position.x,
                    Long: isCustomPresent.position.y
                }
            }
            else {
                obj = {
                    ...masterCollection[i],
                    Lat: 0.0,
                    Long: 0.0
                }
            }
            updateMarkerData.push(obj)
        }

        let userId = JSON.parse(localStorage.getItem("user"));

        const saveObj = {
            userId: userId?.Id,
            siteId: selectedZone?.SiteID,
            isMap: selectedItem === "gis_map" ? 1 : 0,
            imageUrl: imageUrl,
            markers: updateMarkerData,
            // customMapMarkers: [],
        }
        addSiteZoneMapAPI(saveObj)
            .then((res) => {
                console.log("SaveObj", res)
                if (res.Status == "success") {
                    // let c = cancelCount + 1;
                    // setCancelCount(c)
                    SuccessToast(res.Message)
                    getZoneList(site?.SiteID);
                    setEditForm(false)
                } else {
                    ErrorToast(res.Message)
                }

            })
    }

    const onSiteMapCancel = async () => {
        await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to cancel the changes made?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Leave!",
        }).then((result) => {
            if (result.isConfirmed) {
                let c = cancelCount + 1;
                setCancelCount(c)
                setEditForm(false)
                getZoneList(site?.SiteID);
            }
        })
    }

    const deleteAllMarkers = async (isFromRadioBtn, val) => {
        await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete all the makers",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Leave!",
        }).then((result) => {
            if (result.isConfirmed) {
                let tempMarkerList = markerList.map((item) => item.DeviceId)
                let secondTempMarkerList = droppedItems.map((item) => item.DeviceId)
                let tempArr = deviceMasterList.map((item) => {
                    if (tempMarkerList.includes(item.DeviceId) || secondTempMarkerList.includes(item.DeviceId)) {
                        return {
                            ...item,
                            isSelected: false,
                            isTouched: true
                        }
                    } else {
                        return {
                            ...item
                        }
                    }
                })
                setDeviceList(tempArr)
                setDeviceMasterList(tempArr)
                setMarkerList([])

                // Call API to delete

                // First we filter only those device markers that were touced that is either add or removed.
                let masterCollection = tempArr.filter((item) => item.isTouched);
                let updateMarkerData = []
                for (let i = 0; i < masterCollection.length; i++) {
                    // Check if device id is present in the markersList.
                    let obj = {};
                    obj = {
                        ...masterCollection[i],
                        Lat: 0.0,
                        Long: 0.0
                    }
                    updateMarkerData.push(obj)
                }

                let userId = JSON.parse(localStorage.getItem("user"));

                const saveObj = {
                    userId: userId?.Id,
                    siteId: selectedZone?.SiteID,
                    isMap: null,
                    imageUrl: "",
                    markers: updateMarkerData,
                    // customMapMarkers: [],
                }
                console.log("SaveObj", saveObj)
                addSiteZoneMapAPI(saveObj)
                    .then((res) => {
                        console.log("SaveObj", res)
                        if (res.Status == "success") {
                            // let c = cancelCount + 1;
                            // setCancelCount(c)    
                            SuccessToast(res.Message)
                            getZoneList(site?.SiteID);
                            setSelectedImage(null)
                            setImageFileName("")
                            setImageUrl("")
                            getDeviceBySiteId(site?.SiteID, selectedZone?.SiteID)
                            if(isFromRadioBtn){
                                setSelectedItem(val)
                            }else{
                                setSelectedItem("gis_map")
                            }
                        } else {
                            ErrorToast(res.Message)
                        }

                    })

            }
        })
    }

    return (
        <div className='pt-0 pl-3 pr-3' style={{ height: "100%" }}>
            <ul className="nav nav-pills">
                <li className="GISNavItem">
                    <div
                        // className="nav-link active bottom-three-sites"
                        className={
                            selectedMap === 'GIS Map'
                                ? "nav-link active bottom-three-sites ml-0"
                                : "inactive-text-dashboard nav-link bottom-three-sites ml-0"
                        }
                        onClick={(e) => {
                            if (e.target.type == "radio") {
                                return;
                            }
                            setSelectedMap('GIS Map')
                        }}
                    >
                        <div className="Notificationcheckwithlabel">
                            <input
                                type="radio"
                                name="mapType"
                                id="mapType"
                                value="gis_map"
                                disabled={!editForm}
                                checked={selectedItem === 'gis_map'}
                                onChange={handleChange}
                                style={{ left: '0px', position: 'relative' }}
                            />
                            <label
                                // htmlFor='mapType'
                                style={{ margin: '0px', cursor: 'pointer' }}
                            // onClick={() => setSelectedMap('GIS Map')}
                            >GIS Map</label>
                        </div>
                    </div>
                </li>
                <li className="CustomNavItem">
                    <div
                        // className= "nav-link active bottom-three-sites"
                        className={
                            selectedMap === 'Custom'
                                ? "nav-link active bottom-three-sites ml-0"
                                : "inactive-text-dashboard nav-link bottom-three-sites ml-0"
                        }
                        onClick={(e) => {
                            if (e.target.type == "radio") {
                                return;
                            }
                            setSelectedMap('Custom')
                        }}
                    >
                        <div className="Notificationcheckwithlabel">
                            <input
                                type="radio"
                                name="mapType"
                                id="CustomMap"
                                value="custom"
                                disabled={!editForm}
                                checked={selectedItem === 'custom'}
                                onChange={handleChange}
                                style={{ left: '0px', position: 'relative' }}
                            />
                            <label
                                // htmlFor='CustomMap'
                                style={{ margin: '0px', cursor: 'pointer' }}
                            // onClick={() => setSelectedMap('Custom')}
                            >Custom Map</label>
                        </div>
                    </div>
                </li>
            </ul>

            <div className='MainMapView'>
                {selectedMap === 'GIS Map' && (
                    <>
                        <GoogleMap isDarkTheme={isDarkTheme} deviceList={deviceList} setDeviceList={setDeviceList} deviceMasterList={deviceMasterList} setDeviceMasterList={setDeviceMasterList} editForm={editForm} selectedZone={selectedZone} markerList={markerList} setMarkerList={setMarkerList} selectedItem={selectedItem} />
                    </>
                )}

                {selectedMap === 'Custom' && (
                    <>
                        <div className='MapURLDetails mt-4'>
                            <div className="BulkUploadBrowseDiv MapURLDiv inputMainContainer mb-0">
                                <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Custom Map Path</label>
                                    <input className="BulkUploadInput" placeholder='Ex.: D:\MyDocuments\Projects\MyProject\Images\custom-map.png' disabled={true} value={imageFileName} />
                                </div>
                                <button className="DataAccessEdit" style={{ width: "170px" }} disabled={!editForm} onClick={handleUploadImageClick}>
                                    <input
                                        type="file"
                                        multiple={false}
                                        ref={hiddenCamFileInput}
                                        disabled={!editForm}
                                        onChange={handleImageChange}
                                        style={{ display: "none" }}
                                        value=""
                                        accept="image/*"
                                    />
                                    <span className="ViewUpdate">Browse and Upload</span>
                                </button>
                            </div>
                        </div>
                        <p className='URL_Text'>Browse and upload any floor map. | File type: .PNG and .JPEG or .JPG | Max file size 5 MB | File Dimensions: Height:400px and Width: 800px</p>
                        <CustomImageMap isDarkTheme={isDarkTheme} deviceList={deviceList} setDeviceList={setDeviceList} selectedImage={selectedImage} deviceMasterList={deviceMasterList} setDeviceMasterList={setDeviceMasterList} editForm={editForm} droppedItems={droppedItems} setDroppedItems={setDroppedItems} />
                    </>
                )}

                <MapButtons editForm={editForm} disableButton={disableButton} setEditForm={setEditForm} onSaveMapDetails={onSaveMapDetails} onSiteMapCancel={onSiteMapCancel} deleteAllMarkers={deleteAllMarkers} />
            </div>
        </div>
    )
}

export default ZoneMap